import React, { useEffect, useState } from 'react';
import styles from './SideBar.module.scss';
import { generatePath, NavLink, useHistory } from 'react-router-dom';
import { routes } from '../../assets/routes';
import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import {
  get_user_info,
  getMyProfileRequest,
  getNotificationsCountRequest,
  getOrganizationFeaturesRequest
} from '../../helpers/api';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import LocalPlayRoundedIcon from '@material-ui/icons/LocalPlayRounded';
import PollIcon from '@material-ui/icons/Poll';
// import ShowChartIcon from '@material-ui/icons/ShowChart';
import Logo from '../../assets/icons/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { Coin, MoneyBag } from '../../assets/icons/iconComponents2';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import SettingsIcon from '@material-ui/icons/Settings';
import TimelineRoundedIcon from '@mui/icons-material/TimelineRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import classNames from 'classnames';
import { setUserInfo } from '../../reactRedux/Actions/userAction';
import { toast } from 'react-toastify';
import AvatarReco from './AvatarReco';
import { IconButton } from '@material-ui/core';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { modules } from '../../helpers/modules';
import PropTypes from 'prop-types';
// import DashboardIcon from '@material-ui/icons/Dashboard';
import Skeleton from './Skeleton';
import { useQuery } from '@tanstack/react-query';
import CakeIcon from '@material-ui/icons/Cake';
import Button from '@mui/material/Button';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { useTranslation } from '../../i18n/LanguageProvider';
const SideBar = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  // const env = process.env.REACT_APP_ENV;

  const [location, setLocation] = useState(props.location.pathname);
  const currentPath = window.location.pathname;

  const userInfo = useSelector((state) => state.userReducer);
  const showBack = useSelector((state) => state.sideBarReducer.showBack);
  const [notificationCount, setNotificationCount] = useState(0);
  const userInfoUpdate = (data) => dispatch(setUserInfo(data));

  const { data, isLoading, refetch } = useQuery(
    ['myProfile'],
    getMyProfileRequest,
    {
      onSuccess(response) {
        if (response.organization.is_active === false) {
          const deleteAllCookies = () => {
            const cookies = document.cookie.split('; ');
            cookies.forEach((cookie) => {
              const eqPos = cookie.indexOf('=');
              const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
              document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            });
          };

          deleteAllCookies();

          sessionStorage.clear();
          localStorage.clear();

          window.location.reload();
          return;
        }
        userInfoUpdate({
          username: response.username,
          credit: response.credit,
          score: response.score,
          full_name: `${response.first_name} ${response.last_name}`,
          avatar: response?.avatar?.thumbnail
        });
      },
      onError(err) {
        toast.error(err.response?.data.detail);
      }
    }
  );

  useQuery(['notificationsCount'], getNotificationsCountRequest, {
    onSuccess({ data: { notif_count, todo_count } }) {
      setNotificationCount(notif_count + todo_count);
    }
  });

  const { data: orgFeatures } = useQuery(
    ['organizationFeatures'],
    getOrganizationFeaturesRequest
  );

  useEffect(
    () => setLocation(props.location.pathname),
    [props.location.pathname]
  );

  useEffect(() => refetch(), [location]);

  const openSettings = (e) => {
    e.stopPropagation();
    history.push(routes.SETTINGS);
  };

  const hasFeedback = orgFeatures?.data?.find(
    (feature) => feature.feature_name === 'feedback'
  )?.active;

  return (
    <aside className={styles.wrapper}>
      <div className={styles.container}>
        {/*<div*/}
        {/*  className={styles.guidline}*/}
        {/*  onClick={() => (window.location.href = 'https://o2reco.ir/help')}*/}
        {/*>*/}
        {/*  <QuestionMarkIcon />*/}
        {/*</div>*/}
        {isLoading ? (
          <div className={styles.logo}>
            <Skeleton width={80} height={80} />
          </div>
        ) : (
          <img
            src={
              data.organization.logo?.thumbnail
                ? data.organization.logo?.thumbnail
                : Logo
            }
            alt="logo"
            className={styles.logo}
          />
        )}
        {/*<span className={styles.name}>{userInfo.full_name}</span>*/}
        <div className={styles.coins}>
          <div>
            <div>
              <Coin />
              <span>{t('common.scoreLabel')}</span>
            </div>
            <span>{userInfo.score}</span>
          </div>
          <div>
            <div>
              <MoneyBag />
              <span>{t('common.creditLabel')}</span>
            </div>
            <span>{userInfo.credit}</span>
          </div>
        </div>
        <Button
          variant="gradient"
          className={styles.kudosBtn}
          onClick={() => history.push(routes.GIVE_KUDOS)}
        >
          {t('nav.giveKudos')}
        </Button>
        <NavLink
          className={styles.nav}
          to={routes.HOME}
          onClick={(e) =>
            currentPath === routes.HOME ? e.preventDefault() : null
          }
        >
          <HomeRoundedIcon fontSize={'default'} />
          <span>{t('nav.home')}</span>
        </NavLink>
        <NavLink
          className={styles.nav}
          to={routes.MOOD_TRACKER}
          onClick={(e) =>
            currentPath === routes.MOOD_TRACKER ? e.preventDefault() : null
          }
        >
          <TimelineRoundedIcon fontSize={'default'} />
          <span>{t('nav.moodTracker')}</span>
        </NavLink>
        <NavLink
          className={styles.nav}
          to={routes.ANNOUNCEMENTS}
          onClick={(e) =>
            currentPath === routes.ANNOUNCEMENTS ? e.preventDefault() : null
          }
        >
          <CampaignRoundedIcon fontSize={'default'} />
          <span>{t('nav.announcements')}</span>
        </NavLink>
        <NavLink
          className={styles.nav}
          to={routes.OCCASIONS}
          onClick={(e) =>
            currentPath === routes.OCCASIONS ? e.preventDefault() : null
          }
        >
          <CakeIcon />
          <span>{t('nav.occasions')}</span>
        </NavLink>
        <NavLink
          className={styles.nav}
          to={routes.GIFT}
          onClick={(e) =>
            currentPath === routes.GIFT ? e.preventDefault() : null
          }
        >
          <LocalPlayRoundedIcon fontSize={'default'} />
          <span>{t('nav.rewards')}</span>
        </NavLink>
        {modules.survey && (
          <NavLink
            className={styles.nav}
            to={routes.SURVEYS}
            onClick={(e) =>
              currentPath === routes.SURVEY ? e.preventDefault() : null
            }
          >
            <PollIcon />
            <span>{t('nav.surveys')}</span>
          </NavLink>
        )}
        {hasFeedback && (
          <NavLink
            className={styles.nav}
            to={routes.FEEDBACKS}
            onClick={(e) =>
              currentPath === routes.FEEDBACKS ? e.preventDefault() : null
            }
          >
            <QuestionAnswerIcon />
            <span>{t('nav.conversations')}</span>
          </NavLink>
        )}
        <NavLink
          className={styles.nav}
          to={routes.NOTIFICATION_LIST}
          onClick={(e) =>
            currentPath === routes.NOTIFICATION_LIST ? e.preventDefault() : null
          }
        >
          <NotificationsIcon />
          <span>{t('nav.notifications')}</span>
          {notificationCount > 0 ? (
            <span id={'name'} className={styles.counter}>
              {notificationCount}
            </span>
          ) : null}
        </NavLink>
        <NavLink
          className={styles.nav}
          to={routes.SEARCH}
          onClick={(e) =>
            currentPath === routes.SEARCH ? e.preventDefault() : null
          }
        >
          <SearchRoundedIcon fontSize={'default'} />
          <span>{t('nav.search')}</span>
        </NavLink>
        <NavLink
          className={styles.nav}
          to={'https://o2reco.ir/help'}
          onClick={(e) =>
            window.open(
              'https://o2reco.ir/help',
              '_blank',
              'noopener,noreferrer'
            )
              ? e.preventDefault()
              : null
          }
        >
          <QuestionMarkIcon fontSize={'default'} />
          <span>{t('nav.help')}</span>
        </NavLink>
        {/*{(data?.is_org_admin ||*/}
        {/*  data?.is_sys_admin ||*/}
        {/*  data?.is_department_manager) && (*/}
        {/*  <>*/}
        {/*    <div className={styles.nav}>ادمین سازمان</div>*/}
        {/*    {(data?.is_org_admin || data?.is_sys_admin) &&*/}
        {/*      data?.organization.bi_dashboard_link && (*/}
        {/*        <a*/}
        {/*          className={styles.nav}*/}
        {/*          href={data.organization.bi_dashboard_link}*/}
        {/*          target="_blank"*/}
        {/*          rel="noreferrer"*/}
        {/*        >*/}
        {/*          <ShowChartIcon />*/}
        {/*          <span>داشبورد bi</span>*/}
        {/*        </a>*/}
        {/*      )}*/}
        {/*    <a*/}
        {/*      href={*/}
        {/*        env === 'demo'*/}
        {/*          ? 'https://demo-admin.o2reco.ir'*/}
        {/*          : 'https://admin.o2reco.ir'*/}
        {/*      }*/}
        {/*      className={styles.nav}*/}
        {/*      target="_blank"*/}
        {/*      rel="noreferrer"*/}
        {/*    >*/}
        {/*      <DashboardIcon />*/}
        {/*      <span>ادمین پنل</span>*/}
        {/*    </a>*/}
        {/*  </>*/}
        {/*)}*/}
        <div className={styles.profileWrapper}>
          <NavLink
            className={classNames(styles.nav, styles.profile)}
            to={generatePath(routes.PROFILE, { id: get_user_info()?.id || 0 })}
            onClick={(e) =>
              currentPath === routes.PROFILE ? e.preventDefault() : null
            }
          >
            <AvatarReco size={4} avatar={userInfo?.avatar} />
            <span>{userInfo.full_name}</span>
          </NavLink>
          <IconButton
            className={styles.settings}
            onClick={openSettings}
            edge="start"
            size="small"
          >
            <SettingsIcon />
          </IconButton>
        </div>
      </div>

      {showBack && (
        <button
          className={classNames(styles.sideBtn, styles.back)}
          onClick={history.goBack}
        >
          <span>{t('nav.back')}</span>
          <ArrowBackIosRoundedIcon />
        </button>
      )}
    </aside>
  );
};

SideBar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  children: PropTypes.node
};

export default SideBar;
